export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlWarnLogQuery: function smartControlWarnLogQuery(data) {
      return request({
        url: "/iot/smartControlWarnLog/query",
        method: 'get',
        params: data
      });
    },
    smartControlWarnLogDel: function smartControlWarnLogDel(handleId) {
      return request({
        url: "/iot/smartControlWarnLog/".concat(handleId, "/del"),
        method: 'DELETE'
      });
    }
  };
});